var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("signinPage.title")))]),
        _c(
          "router-link",
          { staticClass: "sign-up-link", attrs: { to: _vm.signUpLocation } },
          [_vm._v(_vm._s(_vm.$t("signinPage.signUpLink")))]
        ),
        _c("text-field", {
          staticClass: "input",
          attrs: {
            type: "email",
            label: _vm.$t("signinPage.emailLabel"),
            placeholder: _vm.$t("signinPage.emailPlaceholder"),
          },
          model: {
            value: _vm.email,
            callback: function ($$v) {
              _vm.email = $$v
            },
            expression: "email",
          },
        }),
        _c("text-field", {
          staticClass: "input",
          attrs: {
            type: "password",
            label: _vm.$t("signinPage.passwordLabel"),
            placeholder: _vm.$t("signinPage.passwordPlaceholder"),
          },
          model: {
            value: _vm.password,
            callback: function ($$v) {
              _vm.password = $$v
            },
            expression: "password",
          },
        }),
        _c(
          "div",
          { staticClass: "sign-in-container" },
          [
            _c("p", { staticClass: "sign-in-txt" }, [
              _vm._v(" " + _vm._s(_vm.$t("signinPage.agreementText")) + " "),
              _c("a", { attrs: { href: "/terms", target: "blank" } }, [
                _vm._v(_vm._s(_vm.$t("common.termsOfService"))),
              ]),
              _vm._v(_vm._s(_vm.$t("signinPage.and"))),
              _c("a", { attrs: { href: "/privacy", target: "blank" } }, [
                _vm._v(_vm._s(_vm.$t("signinPage.privacyPolicy"))),
              ]),
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("signinPage.agreementTextSuffix")),
                },
              }),
            ]),
            _c(
              "button-default",
              {
                staticClass: "login-button",
                attrs: { disabled: _vm.submitting },
              },
              [
                _vm.submitting
                  ? _c(
                      "span",
                      { staticClass: "login-button-content" },
                      [
                        _c("icon-spinner", {
                          staticClass: "login-button-spinner",
                        }),
                        _vm._v(" " + _vm._s(_vm.$t("common.loggingIn")) + " "),
                      ],
                      1
                    )
                  : _c("span", [_vm._v(_vm._s(_vm.$t("common.login")))]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "setting" },
          [
            _c("router-link", { attrs: { to: { name: "resetPassword" } } }, [
              _vm._v(_vm._s(_vm.$t("signinPage.forgotPasswordLink"))),
            ]),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: { href: _vm.help, target: "blank" },
              },
              [_vm._v(_vm._s(_vm.$t("signinPage.helpLink")))]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm.message
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.message) } })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }